import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"
import {CustomerPortalTasksAccess} from "../../../model2/project/types"
import Project from "../../../model2/project/project"
import ProjectSession from "../../../model2/project/project-session"

const fieldsConfig = {

    'portalEnabled': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : false,
        options         : [true, false]
    },
    'projectViews': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : null
        // options         : ['default','small']
    },
    tasksAccess     : {
        type            : ServerSettingsFieldType.OPTION,
        options         : [CustomerPortalTasksAccess.ALL_TASKS, CustomerPortalTasksAccess.BY_CRM_CONTACT],
        defaultValue    : undefined
    }
}

const debug = false
// const debug = "ProjectSettings_CRM"

export default class ProjectSettings_CRM extends ServerSettings {

    public project          : Project   // link to project this settings belong to

    public portalEnabled    : boolean
    public projectViews     : any[] | null
    public _tasksAccess     : CustomerPortalTasksAccess

    constructor(config: any, project:Project) {
        super(config, fieldsConfig)

        debug && console.log(debug, "constructor() ",config, this._config)

        this.project                = project

        this.portalEnabled          = this.initValue('portalEnabled')
        this.projectViews           = this.initValue('projectViews')
        this._tasksAccess           = this.initValue('tasksAccess') // _.get(config, 'tasksAccess', undefined)

        debug && console.log(debug, this._config)
    }

    get tasksAccess() {
        if (this._tasksAccess) {
            debug && console.log(debug, "tasksAccess from the project itself")
            return this._tasksAccess
        }

        // const allParents = gd.session.projects.getAllParents(this.project.id).reverse()
        // const allParents = this.project.parentProjects

        // this.project is of ProjectModelSession class (src/core/gd-model/project-session/project-model-session.js)
        // @ts-ignore
        const inheritFromProject: ProjectSession | null = _.find(gd.session.projects.getAllParents(this.project.id).reverse(), (parentProject:ProjectSession)=>{``

            if (!parentProject.settings) {
                console.error("#043984875 project", parentProject.id, parentProject.name, "Doesn't have settings...")
                return false
            }

            if (parentProject.settings.crm._tasksAccess) {
                return !!parentProject.settings.crm._tasksAccess
            }
        })

        if (inheritFromProject) {
            debug && console.log(debug, "tasksAccess Inherited from project", inheritFromProject)
            return inheritFromProject.settings!.crm._tasksAccess
        }

        debug && console.log(debug, "tasksAccess no value... default")
        return CustomerPortalTasksAccess.ALL_TASKS
    }

    set tasksAccess(taskAccess: CustomerPortalTasksAccess) {
        this._tasksAccess = taskAccess
    }

    toJson() {

        const result :any = {}

        this.valueToJson(result, 'portalEnabled')
        this.valueToJson(result, 'projectViews')
        // this.valueToJson(result, 'tasksAccess')
        if (this._tasksAccess) {
            result.tasksAccess = this._tasksAccess
        }

        return result;
    }
}
